<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     模型管理-图标管理
  | @Version:   2019-08-05  [A] 新建文件
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog
    custom-class="link-single-editer"
    :visible.sync="dialogShow"
    width="1400px"
    :close-on-click-modal="false"
    :modal-append-to-body="true"
    append-to-body
  >
    <div slot="title" class="font-2x" >
      <el-tabs v-model="activeIndex" class="tabs-contar" @tab-click="handleSelect">
        <el-tab-pane label="收藏" name="1"></el-tab-pane>
        <el-tab-pane label="公共库" name="2"></el-tab-pane>
      </el-tabs>
    </div>

    <div v-if="activeIndex == '1'" class="flex pb" style="position:sticky;padding-right:25px;">
      <el-alert :type=" orderMode ? 'success' : 'ww'" :closable="false">
        <div slot="title" class="flex align-items-center" style="height:36px;">
          <div class="bd">
            <span v-if="orderMode">已进入排序模式，拖动图标进行排序，排序完成后请点击保存按钮.</span>
          </div>
          <div class="ft" style="position:absolute; right:15px;">
            <el-button
              v-if="!orderMode"
              icon="el-icon-circle-plus-outline"
              type="primary"
              @click="editIcon(0)"
            >新图标</el-button>
            <el-button
              v-if="orderMode"
              type="primary"
              class="span"
              :loading="posting"
              @click="save"
            >保 存</el-button>
            <el-button
              type="primary"
              plain
              :icon="orderMode ? '' : 'iconfont icon-sort'"
              @click="changeMode"
            >{{ orderMode ? '取消' : '排序' }}</el-button>
          </div>
        </div>
      </el-alert>
    </div>
    <div class="dev-icon-list">
      <draggable
        v-if="activeIndex == '1'"
        v-model="icons"
        v-loading="loading"
        :options="{ disabled: !orderMode }"
      >
        <transition-group
          type="transition"
          :name="'flip-list'"
          style="display: flex;flex-wrap: wrap;"
        >
          <el-card
            v-for="icon in icons"
            :key="icon.iconid + activeIndex"
            class="icon-item"
            :class="{ move: orderMode }"
            :body-style="{ padding: '0px 0px 5px 0px' }"
            @mouseenter.native="onMouseEnter(icon)"
            @mouseleave.native="onMouseLeave(icon)"
          >
            <label v-if="icon.icon_url_2" class="multi-icon-flag">
              <i class="el-icon-copy-document"></i>
            </label>
            <img
              :src="currentIcon.iconid === icon.iconid && icon.icon_url_2 ? icon.icon_url_2 : icon.icon_url"
              class="image"
            />
            <div v-if="!orderMode" class="icon-item-footer">
              <span v-if="currentIcon.iconid !== icon.iconid">{{ icon.icon_title }}</span>
              <div
                v-if="currentIcon.iconid === icon.iconid && activeIndex == '1'"
                style="display: flex;justify-content: space-around;"
              >
                <span class="text-primary" role="button" @click="editIcon(icon.iconid)">编辑</span>
                <span class="text-primary" role="button" @click="deleteIcon(icon)">删除</span>
              </div>
              <div
                v-if="currentIcon.iconid === icon.iconid && activeIndex == '2'"
                style="display: flex;justify-content: space-around;"
              >
                <span class="text-primary" role="button" @click="collectIcon(icon.iconid)">收藏</span>
              </div>
            </div>
          </el-card>
        </transition-group>
      </draggable>
      <div v-if="activeIndex == '2'" class="dev-icon-list" style="display: flex;flex-wrap: wrap;">
        <el-card
          v-for="icon in icons"
          :key="icon.iconid + activeIndex"
          class="icon-item"
          :class="{ move: orderMode }"
          :body-style="{ padding: '0px 0px 5px 0px' }"
          @mouseenter.native="onMouseEnter(icon)"
          @mouseleave.native="onMouseLeave(icon)"
        >
          <label v-if="icon.icon_url_2" class="multi-icon-flag">
            <i class="el-icon-copy-document"></i>
          </label>
          <img
            :src="currentIcon.iconid === icon.iconid && icon.icon_url_2 ? icon.icon_url_2 : icon.icon_url"
            class="image"
          />
          <div v-if="!orderMode" class="icon-item-footer">
            <span v-if="currentIcon.iconid !== icon.iconid">{{ icon.icon_title }}</span>
            <div
              v-if="currentIcon.iconid === icon.iconid && activeIndex == '1'"
              style="display: flex;justify-content: space-around;"
            >
              <span class="text-primary" role="button" @click="editIcon(icon.iconid)">编辑</span>
              <span class="text-primary" role="button" @click="deleteIcon(icon)">删除</span>
            </div>
            <div
              v-if="currentIcon.iconid === icon.iconid && activeIndex == '2'"
              style="display: flex;justify-content: space-around;"
            >
              <span class="text-primary" role="button" @click="collectIcon(icon.iconid)">收藏</span>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <dev-icon-post
      v-if="iconEditing"
      :show.sync="iconEditing"
      :iconid="activeIconid"
      @success="onPostSuccess"
    />
  </el-dialog>
</template>

<script>
import draggable from "vuedraggable";
import DevIconPost from "./DevIconPost";
import {
  getAllIconApi,
  deleteIconApi,
  rankIconApi,
  getPublicIconApi,
  collectIconApi,
} from "@/api/iconApi";
export default {
  name: "DevIconList",
  components: { draggable, DevIconPost },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      posting: false,
      icons: [],
      currentIcon: {},
      iconEditing: false,
      activeIconid: 0,
      orderMode: false,
      activeIndex: "1",
      activeName: "first",
    };
  },
  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },

    devid() {
      return this.$store.state.devStore.devid
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData(quiet) {
      if (!quiet) this.loading = true;
      let request = null;
      if (this.activeIndex == "1") {
        request = this.$store.dispatch("getallIconAction");
      } else {
        request = getPublicIconApi();
      }
      request.then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.icons = Object.assign([], res.data.list);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onMouseEnter(icon) {
      this.currentIcon = Object.assign({}, icon);
    },
    onMouseLeave(icon) {
      this.currentIcon = {};
    },
    editIcon(iconid) {
      this.activeIconid = iconid;
      this.iconEditing = true;
    },
    onPostSuccess() {
      this.fetchData(true);
    },
    deleteIcon(icon) {
      const msg = `此操作将删除 <span class="text-danger">${icon.icon_title}</span> 图标，是否继续？`;
      this.$confirm(msg, {
        type: "error",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          deleteIconApi({ iconids: [icon.iconid] }).then((res) => {
            if (!res.errno) {
              this.$message.success(res.message);
              this.fetchData(true);
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeMode() {
      this.orderMode = !this.orderMode;
      if (!this.orderMode) {
        this.fetchData(true);
      }
    },
    save() {
      this.posting = true;
      const iconids = this.icons.map((item) => {
        return item.iconid;
      });
      rankIconApi({ iconids }).then((res) => {
        this.posting = false;
        if (!res.errno) {
          this.$message.success(res.message);
          this.orderMode = false;
          this.fetchData(true);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    handleSelect() {
      this.loading = true;
      this.icons = [];
      this.fetchData(0);
    },

    collectIcon(iconid) {
      collectIconApi({ iconid }).then((res) => {
        if (!res.errno) {
          this.$message.success(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" slot-scoped>
.link-single-editer {
  .el-menu--horizontal > .el-menu-item {
    height: 46px;
    display: flex;
    align-items: center;
    font-size: 20px;
  }
  .el-dialog__header {
    padding-bottom: 0;
    padding-top: 13px;
  }
  .el-dialog__body {
    padding-top: 0;
    padding-right: 0;
    min-height: 640px;
  }
  .el-dialog__close {
    font-size: 20px;
  }
}

.dev-icon-list {
  position: relative;
  max-height: 540px;
  overflow: auto;
  .icon-item {
    margin-right: 15px;
    margin-bottom: 15px;
    position: relative;
    &.move {
      cursor: move;
    }
    .multi-icon-flag {
      position: absolute;
      right: -15px;
      top: -6px;
      width: 40px;
      height: 24px;
      background: #07c160;
      text-align: center;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
      -webkit-box-shadow: 0 0 1pc 1px rgba(0, 0, 0, 0.2);
      box-shadow: 0 0 1pc 1px rgba(0, 0, 0, 0.2);
      i {
        font-size: 12px;
        color: #fff;
        margin-top: 10px;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
      }
    }
    .icon-item-footer {
      text-align: center;
      border-top: 1px solid #dcdfe6;
      padding-top: 5px;
    }
  }
  .image {
    width: 120px;
    height: 120px;
    vertical-align: top;
  }
}
</style>
<style lang="scss">
.tabs-contar > .el-tabs__header > .el-tabs__nav-wrap {
  .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
    .el-tabs__item {
      font-size: 20px;
      padding: 0px 20px 20px;
    }
  }
  &::after {
    height: 1px;
  }
}
</style>